/* tslint:disable */
import {
  UserData,
  Card
} from '../index';

declare var Object: any;
export interface ActivationInterface {
  "userId": number;
  "cardId": string;
  "dateCreated": Date;
  "email"?: string;
  "error"?: string;
  "id"?: number;
  user?: UserData;
  card?: Card;
}

export class Activation implements ActivationInterface {
  "userId": number;
  "cardId": string;
  "dateCreated": Date;
  "email": string;
  "error": string;
  "id": number;
  user: UserData;
  card: Card;
  constructor(data?: ActivationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Activation`.
   */
  public static getModelName() {
    return "Activation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Activation for dynamic purposes.
  **/
  public static factory(data: ActivationInterface): Activation{
    return new Activation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Activation',
      plural: 'Activations',
      path: 'Activations',
      idName: 'id',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "cardId": {
          name: 'cardId',
          type: 'string'
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "error": {
          name: 'error',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        user: {
          name: 'user',
          type: 'UserData',
          model: 'UserData',
          relationType: 'belongsTo',
                  keyFrom: 'userId',
          keyTo: 'id'
        },
        card: {
          name: 'card',
          type: 'Card',
          model: 'Card',
          relationType: 'belongsTo',
                  keyFrom: 'cardId',
          keyTo: 'id'
        },
      }
    }
  }
}
